export const sectionData = [
    {
        id: 1,
        title: 'Интернет, который не подведёт',
        text: 'Будьте уверены — интернет не пропадет и в нужный момент будет всегда под рукой. Сеть под нашим контролем круглосуточно.',
    },
    {
        id: 2,
        title: 'Домашний Wi-Fi с умом',
        text: 'Инженеры рассчитают где и как разместить оборудование. Установят его так, чтобы Wi-Fi был в каждом уголке квартиры.',
    },
    {
        id: 3,
        title: 'Поддержка клиентов и днём, и ночью',
        text: 'Дом.ру на связи со своими Клиентами 24/7. Ответим на все вопросы и решим любые затруднения.',
    },
];
